module.exports = __webpack_public_path__ + "static/thinking_emoji-b7f765737c39d58fe0ca26d7c7a231d1.svg";